/* global Clipboard */
Wee.fn.make('copyUrl', {
	init: function() {
		this.$private.copyUrl();
	},
	unload: function() {
		this.$private.clipboard.destroy();
	}
}, {
	copyUrl: function() {
		var scope = this,
			$copyLink = $('ref:copyUrl'),
			copiedClass = '-copied';

		scope.clipboard = new Clipboard($copyLink[0], {
			text: function() {
				return $._win.location.href;
			}
		});

		scope.clipboard.on('success', function() {
			$copyLink.addClass(copiedClass);

			setTimeout(function() {
				$copyLink.removeClass(copiedClass);
			}, 1000);
		});
	}
});